.option {
  border-radius: 0;
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-lg);

  &:hover {
    background-color: var(--mantine-color-primary-light);
  }

  &[data-combobox-active] {
    background-color: var(--mantine-color-primary-light);
  }

  &[data-combobox-selected] {
    background-color: var(--mantine-color-primary-filled);
    color: white;
  }

  &:not(:last-child) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.options {
  padding: 0;
}

.dropdown {
  border-color: var(--mantine-color-primary-filled);
  outline: var(--mantine-spacing-xs) solid var(--mantine-color-primary-light);
  overflow: hidden;
  padding: 0;

  &[data-position="bottom"] {
    border-top: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  &[data-position="top"] {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
}